"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _reducers = require("../../reducers");

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _AppContext = _interopRequireDefault(require("../../context/AppContext"));

var _context = require("../../actions/context");

var _usePrevious = _interopRequireDefault(require("../../hooks/usePrevious"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var useClearAnnotationLocation = function useClearAnnotationLocation() {
  var appContext = (0, _react.useContext)(_AppContext.default);
  var dispatch = (0, _reducers.useDispatch)();
  var currentDependencies = {
    assetDataId: appContext.assetData.id,
    touchControls: appContext.touchControls,
    annotationsEnabled: appContext.annotationsEnabled,
    environment: appContext.environment,
    disableCommentCreation: appContext.disableCommentCreation,
    annotationTypes: appContext.annotationTypes
  };
  var previousDependencies = (0, _usePrevious.default)(currentDependencies); // we only want to call when a value changes, annotationTypes being an object causes issues, as its liable to change

  (0, _react.useEffect)(function () {
    if (!(0, _lodash.default)(currentDependencies, previousDependencies)) {
      (0, _reactRedux.batch)(function () {
        dispatch((0, _context.contextSaveAnnotationLocation)());
        dispatch((0, _context.contextSetAnnotationMode)());
      });
    }
  });
};

var _default = useClearAnnotationLocation;
exports.default = _default;